import { ClientConfigurationSecret } from './client-config-secret';

export class ClientConfigurationSecretComparison {
    compareSecret: ClientConfigurationSecret;
    
    secrets : ClientConfigurationSecret[];
}